var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "WebAuth",
            "fields": [],
            "messages": [
                {
                    "name": "AuthPro",
                    "fields": [],
                    "options": {
                        "objc_class_prefix": "WebAuthAuthPro",
                        "java_package": "com.asiainno.uplive.proto"
                    },
                    "messages": [
                        {
                            "name": "Request",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "authcode",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "feature",
                                    "id": 2
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "channel",
                                    "id": 3
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "deviceType",
                                    "id": 4
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "version",
                                    "id": 5
                                },
                                {
                                    "rule": "optional",
                                    "type": "BindType",
                                    "name": "type",
                                    "id": 6
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "tokenSecret",
                                    "id": 7
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "verifier",
                                    "id": 8
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "callback",
                                    "id": 9
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "state",
                                    "id": 10
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "deviceId",
                                    "id": 11
                                }
                            ]
                        },
                        {
                            "name": "Response",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "int64",
                                    "name": "uid",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "userToken",
                                    "id": 2
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "subscribe",
                                    "id": 3
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "code",
                                    "id": 4
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "enums": [
        {
            "name": "BindType",
            "values": [
                {
                    "name": "DEFAULT_TYPE",
                    "id": 0
                },
                {
                    "name": "MOBILE_PHONE",
                    "id": 1
                },
                {
                    "name": "QQ",
                    "id": 2
                },
                {
                    "name": "WEIXIN",
                    "id": 3
                },
                {
                    "name": "FACEBOOK",
                    "id": 4
                },
                {
                    "name": "SINA_WEIBO",
                    "id": 5
                },
                {
                    "name": "RR",
                    "id": 6
                },
                {
                    "name": "TENCENT_WANBA",
                    "id": 7
                },
                {
                    "name": "KECHENGGEZI",
                    "id": 8
                },
                {
                    "name": "DEVICE",
                    "id": 9
                },
                {
                    "name": "GOOGLE",
                    "id": 15
                },
                {
                    "name": "TWITTER",
                    "id": 16
                },
                {
                    "name": "EMAIL",
                    "id": 17
                },
                {
                    "name": "LINE_BIND",
                    "id": 19
                },
                {
                    "name": "KAKAO",
                    "id": 20
                },
                {
                    "name": "WEIXIN_MINI_PROGRAM",
                    "id": 21
                },
                {
                    "name": "TELEGRAM",
                    "id": 23
                }
            ]
        },
        {
            "name": "PushType",
            "values": [
                {
                    "name": "DEFAULT_PUSHTYPE",
                    "id": 0
                },
                {
                    "name": "BAIDU",
                    "id": 1
                },
                {
                    "name": "IOS",
                    "id": 2
                },
                {
                    "name": "JPUSH",
                    "id": 3
                },
                {
                    "name": "XIAOMI",
                    "id": 4
                },
                {
                    "name": "GETUI",
                    "id": 5
                },
                {
                    "name": "GOOGLE_PUSH",
                    "id": 6
                },
                {
                    "name": "SAMSUNG",
                    "id": 7
                },
                {
                    "name": "MEIZU",
                    "id": 8
                },
                {
                    "name": "HUAWEI",
                    "id": 9
                },
                {
                    "name": "GOOGLE_FCM",
                    "id": 10
                }
            ]
        },
        {
            "name": "LiveType",
            "values": [
                {
                    "name": "PUBLIC_FREE",
                    "id": 0
                },
                {
                    "name": "PUBLIC_CHARGE",
                    "id": 1
                },
                {
                    "name": "PRIVATE_FREE",
                    "id": 2
                },
                {
                    "name": "PRIVATE_CHARGE",
                    "id": 3
                }
            ]
        }
    ]
}).build();
export default _root;



// WEBPACK FOOTER //
// ./js/pb/webauthauthpro.pb.js